import { getAxiosInstance } from "../../api";

export const menuThumbnailList = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("admin/menu-thumbnail/list", params);
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};

export const uploadMenuThumbnails = async (formData, onUploadProgress) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("admin/menu-thumbnail/upload", formData, { onUploadProgress });
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};

export const deleteMenuThumbnails = async (ids) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.delete("admin/menu-thumbnail/delete", { data: { _id: ids } });
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};
